import { Box, Dialog } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';
import React from 'react';
import { SANS_STACK, TEXT_BODY } from './common/tokens';
import {
  DIALOG_PAPER_SX, DialogCloseButton, DialogFooter, DialogHeader,
  DialogPrimaryButton, DialogTextButton, DialogTitle,
} from './common/dialog/primitives';

function ConfirmDialog(props) {
  const {
    open, title, message, confirmLabel, cancelLabel, destructive, onConfirm, onCancel, onExited,
  } = props;

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      maxWidth="xs"
      fullWidth
      PaperProps={{ elevation: 0, sx: DIALOG_PAPER_SX }}
      TransitionProps={{ onExited }}
    >
      <DialogHeader>
        <DialogTitle>{title}</DialogTitle>
        <DialogCloseButton onClick={onCancel} aria-label="Close">
          <CloseIcon />
        </DialogCloseButton>
      </DialogHeader>

      {message != null && (
        <Box
          sx={{
            px: 2,
            pt: 0.5,
            pb: 1.5,
            fontFamily: SANS_STACK,
            fontSize: 13.5,
            lineHeight: 1.5,
            color: TEXT_BODY,
          }}
        >
          {message}
        </Box>
      )}

      <DialogFooter sx={{ justifyContent: 'flex-end', gap: 1 }}>
        <DialogTextButton onClick={onCancel}>{cancelLabel}</DialogTextButton>
        <DialogPrimaryButton
          destructive={destructive}
          disableElevation
          variant="contained"
          onClick={onConfirm}
          autoFocus
        >
          {confirmLabel}
        </DialogPrimaryButton>
      </DialogFooter>
    </Dialog>
  );
}

ConfirmDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  title: PropTypes.string,
  message: PropTypes.node,
  confirmLabel: PropTypes.string,
  cancelLabel: PropTypes.string,
  destructive: PropTypes.bool,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onExited: PropTypes.func,
};

ConfirmDialog.defaultProps = {
  title: 'Are you sure?',
  message: null,
  confirmLabel: 'Confirm',
  cancelLabel: 'Cancel',
  destructive: false,
  onExited: undefined,
};

export default ConfirmDialog;
